/* ============================================================
   HIGHWOOD - policy page enhancement (/policies/*)

   Shopify owns the markup on policy pages, so the almanac's two
   structural touches have to be added at runtime:

     1. A jump-link table of contents built from the chapter <h2>s,
        mirroring the marketing site's legal-page TOC.
     2. The opening "Effective ..." / "Last updated ..." line
        promoted to the editorial meta chip.

   Both are enhancements. With this file blocked or broken the page
   still renders as a correctly styled policy, so nothing here
   throws on missing nodes.
   ============================================================ */
(function () {
  'use strict';

  var body = document.querySelector('.shopify-policy__body .rte') ||
             document.querySelector('.shopify-policy__body');
  var title = document.querySelector('.shopify-policy__title');
  if (!body || !title) return;

  /* --- 1. Meta chip ---------------------------------------
     Only promote a leading paragraph that actually reads as a
     date stamp. Two of the six policies open with prose instead,
     and turning a real sentence into a letterspaced mono chip
     would look like a bug. */
  var firstPara = body.querySelector('p');
  if (firstPara) {
    var text = firstPara.textContent.trim();
    var isStamp = /^(effective|last updated|updated)\b/i.test(text) && text.length < 80;
    if (isStamp) {
      firstPara.classList.add('policy-meta');
      title.appendChild(firstPara);
    }
  }

  /* --- 2. Table of contents -------------------------------- */
  var heads = Array.prototype.slice.call(body.querySelectorAll('h2'));
  // One chapter is not a table of contents.
  if (heads.length < 2) return;

  var ROMAN = [
    [1000, 'M'], [900, 'CM'], [500, 'D'], [400, 'CD'],
    [100, 'C'], [90, 'XC'], [50, 'L'], [40, 'XL'],
    [10, 'X'], [9, 'IX'], [5, 'V'], [4, 'IV'], [1, 'I']
  ];
  function roman(n) {
    var out = '';
    for (var i = 0; i < ROMAN.length; i++) {
      while (n >= ROMAN[i][0]) { out += ROMAN[i][1]; n -= ROMAN[i][0]; }
    }
    return out;
  }

  function slug(s) {
    return s.toLowerCase()
      .replace(/[‘’“”]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section';
  }

  var nav = document.createElement('nav');
  nav.className = 'policy-toc';
  nav.setAttribute('aria-label', 'On this page');

  var label = document.createElement('p');
  label.className = 'policy-toc__label';
  label.textContent = 'On this page';
  nav.appendChild(label);

  var list = document.createElement('ol');
  list.className = 'policy-toc__list';

  var used = Object.create(null);

  heads.forEach(function (h, i) {
    var text = h.textContent.trim();

    // Keep ids stable and unique; a duplicate heading would
    // otherwise send every one of its links to the first match.
    var id = h.id;
    if (!id) {
      id = slug(text);
      if (used[id]) { id = id + '-' + (used[id] + 1); }
      h.id = id;
    }
    used[slug(text)] = (used[slug(text)] || 0) + 1;

    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + id;

    var num = document.createElement('span');
    num.className = 'policy-toc__num';
    num.textContent = roman(i + 1);

    var name = document.createElement('span');
    name.className = 'policy-toc__title';
    name.textContent = text;

    a.appendChild(num);
    a.appendChild(name);
    li.appendChild(a);
    list.appendChild(li);
  });

  nav.appendChild(list);
  title.insertAdjacentElement('afterend', nav);
})();
